import { createRoot } from 'react-dom/client';
import App from './App';
import { SessionProvider } from './lib/session';
import { ToastProvider } from './components/Toast';
import { initSentry } from './lib/sentry';
import { initAccent } from './lib/accent';
import './styles/global.css';
import './styles/ds.css';

initSentry();

// Reconcile the runtime brand accent with the server (the inline script
// in index.html already painted the cached value, so this is a no-op
// repaint unless an admin changed it since this browser last loaded).
void initAccent();

const root = document.getElementById('root');
if (!root) throw new Error('[root] #root element not found in index.html');

// Intentionally not wrapping in React.StrictMode. StrictMode double-invokes
// effects in dev which orphans GoTrue's session lock and has historically
// caused 5-second lock-recovery stalls on navigation.
createRoot(root).render(
  <SessionProvider>
    <ToastProvider>
      <App />
    </ToastProvider>
  </SessionProvider>,
);
